module.exports = __webpack_public_path__ + "./a7c768a3b085fb2cd8e0bcfb4da5cf26-service-image-package-large@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/service-picker-options/service-image-package-large@2x.png
// module id = 1871
// module chunks = 0